var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 11.25a4.125 4.125 0 11-8.25 0 4.125 4.125 0 018.25 0zM21 4.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5zm-1.5 15v-15h-15v15h.344a7.554 7.554 0 012.444-3.586c.193-.155.391-.3.596-.433a.375.375 0 01.451.03 5.608 5.608 0 007.33 0 .375.375 0 01.45-.03 7.7 7.7 0 01.597.433 7.554 7.554 0 012.444 3.586h.344z",
    fill: "#818181"
  })));
}

export default SvgProfile;